export default [
    {
        field: 'name',
        type: 'text',
        vuetifyProps: {
            label: 'Nombre',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'dependent_rate',
        type: 'text',
        vuetifyProps: {
            label: 'Tasa trabajadores dependientes',
        },
        rules: [ 'required', 'numeric' ],
        value: '',
    },
    {
        field: 'independent_rate',
        type: 'text',
        vuetifyProps: {
            label: 'Tasa trabajadores independientes',
        },
        rules: [ 'required', 'numeric' ],
        value: '',
    },
    {
        field: 'code',
        type: 'text',
        vuetifyProps: {
            label: 'Código Numérico',
        },
        rules: [ 'required', 'numeric' ],
        value: '',
    },
]